/* ==========================================================================
   Umya · Que la vista previa no se escape
   19-ago-2026

   EN LA TIENDA PUBLICADA ESTE GUION NO HACE NADA. Solo se activa cuando la
   dirección lleva preview_theme_id, es decir, cuando alguien está revisando
   el borrador.

   El problema, medido: entras a la vista previa por
   umyajewelry.myshopify.com, pulsas "Bracelets" y acabas en umya.be con el
   tema viejo. No es culpa del enlace: Shopify redirige el dominio interno al
   principal, y al hacerlo se lleva por delante el tema que estabas mirando.
   El parámetro _fd=0 es lo que frena esa redirección, y preview_theme_id lo
   que dice qué borrador se mira; ninguno de los dos viaja solo.

   Resultado sin esto: para revisar hay que pegar direcciones a mano una por
   una. Que es exactamente lo que no se le puede pedir a la clienta.
   ========================================================================== */

(() => {
  /* Cómo se sabe que esto es una vista previa: NO por la dirección. Shopify
     se come el preview_theme_id en la primera carga y lo guarda en una
     galleta, así que a partir del segundo paso ya no está en la barra
     (comprobado: la dirección se queda en "?_fd=0" a secas). Lo que sí
     queda es el objeto del tema, que dice su papel. */
  const tema = () => window.Shopify && window.Shopify.theme;
  const enPrevia = () => {
    const t = tema();
    return !!t && t.role && t.role !== 'main';
  };
  if (!enPrevia() && !new URLSearchParams(window.location.search).has('preview_theme_id')) {
    // Puede que el objeto aún no esté puesto al leer esto; se vuelve a mirar
    // en cada clic, así que no se sale del todo.
  }

  const mismaTienda = (url) => {
    try {
      const u = new URL(url, window.location.origin);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      const host = u.hostname;
      const propio =
        host === window.location.hostname ||
        host === 'umya.be' ||
        host === 'www.umya.be' ||
        host === 'umyajewelry.myshopify.com';
      if (!propio) return null;
      // Todo se reconduce al dominio por el que se entró a la vista previa.
      u.protocol = window.location.protocol;
      u.host = window.location.host;
      return u;
    } catch (e) {
      return null;
    }
  };

  /* _fd=0 es el que de verdad importa: sin él, Shopify manda la petición al
     dominio principal (umya.be) y allí manda el tema publicado. El
     preview_theme_id se pone además por si la galleta se hubiera perdido. */
  const marcar = (u) => {
    u.searchParams.set('_fd', '0');
    const t = tema();
    if (t && t.id) u.searchParams.set('preview_theme_id', String(t.id));
    ponerPlantilla(u);
    return u;
  };

  /* --------------------------------------------------------------------
     Las plantillas alternativas, mientras el tema siga sin publicar.

     Qué pasa (comprobado 20-ago-2026 en el admin y en los ficheros de los
     dos temas): el desplegable "Plantilla de tema" de un producto solo
     ofrece las plantillas del tema PUBLICADO. El publicado es Brooklyn, que
     tiene una sola (templates/product.liquid). Las cuatro nuestras viven en
     el borrador, así que en el admin no hay nada que elegir: sale
     "Producto predeterminado" y punto.

     No es un fallo nuestro ni de nadie: es cómo funciona Shopify. Se
     arreglará solo el día que se publique Dawn, y entonces la asignación se
     hace en el admin de verdad, que es donde debe estar.

     Mientras tanto, para que la clienta pueda recorrer la tienda sola sin
     que nadie le pegue direcciones raras por WhatsApp, aquí se dice qué
     plantilla toca en las trece fichas que no usan la normal. Solo actúa en
     la vista previa. En la tienda publicada este bloque no se ejecuta.
     -------------------------------------------------------------------- */
  const PLANTILLAS = {
    // Los nueve Choose your stone (encargo a medida)
    osmose: 'a-medida',
    flora: 'a-medida',
    sena: 'a-medida',
    mae: 'a-medida',
    mana: 'a-medida',
    alba: 'a-medida',
    oona: 'a-medida',
    kaha: 'a-medida',
    elira: 'a-medida',
    // El curso, que está subido dos veces (inglés y francés)
    'e-course-basics-of-metalsmithing': 'curso',
    'cours-introduction-bijouterie': 'curso',
    // Lo que no es una joya
    'insured-shipping-with-tracking-belgium-national-shipping': 'no-joya',
    'umya-gift-card': 'no-joya'
  };

  /* Lo mismo, pero para colecciones. Choose your stone tiene su propia
     plantilla (la guía de los nueve modelos, paso a paso) y la colección sin
     ella cae en la rejilla de categoría normal, que es OTRA página.

     Esto se vio el 21-ago-2026: el rótulo del menú llevaba a la rejilla y el
     enlace de dentro del megamenú a la guía. Dos páginas para lo mismo, según
     por dónde entres. Ahora la plantilla la decide este mapa, no el enlace. */
  const PLANTILLAS_COLECCION = {
    'choose-your-stone': 'choose-your-stone'
  };

  /* El camino puede llevar delante el idioma (/fr/products/…) y también
     venir de dentro de una colección (/collections/x/products/y), así que se
     busca el trozo, no se compara la cadena entera. La ficha manda sobre la
     colección: en /collections/choose-your-stone/products/sena lo que se pinta
     es la ficha de Sena, no la guía. */
  const plantillaDe = (ruta) => {
    const camino = ruta || '';
    const p = /\/products\/([^/?#]+)/.exec(camino);
    if (p) return PLANTILLAS[p[1]] || null;
    const c = /\/collections\/([^/?#]+)/.exec(camino);
    return c ? PLANTILLAS_COLECCION[c[1]] || null : null;
  };

  const ponerPlantilla = (u) => {
    if (u.searchParams.has('view')) return u;
    const v = plantillaDe(u.pathname);
    if (v) u.searchParams.set('view', v);
    return u;
  };

  /* Para quien necesite cargar una pagina de la tienda sin salirse del
     borrador (el plan B de product-info.js al elegir piedra). Fuera de la
     vista previa devuelve la direccion tal cual. */
  window.umyaMarcarPrevia = (u) => (enPrevia() ? marcar(u) : u);

  document.addEventListener(
    'click',
    (e) => {
      if (!enPrevia()) return;
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest?.('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;

      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      const u = mismaTienda(a.href);
      if (!u) return;

      e.preventDefault();
      window.location.href = marcar(u).toString();
    },
    true
  );

  /* Los formularios que van por GET (el buscador, sobre todo) pierden lo
     mismo: se les cuelan los dos parámetros como campos ocultos. */
  document.addEventListener(
    'submit',
    (e) => {
      if (!enPrevia()) return;
      const form = e.target;
      if (!form || (form.method || 'get').toLowerCase() !== 'get') return;
      const u = mismaTienda(form.action || window.location.href);
      if (!u) return;
      const t = tema();
      const pares = { _fd: '0' };
      if (t && t.id) pares.preview_theme_id = String(t.id);
      Object.keys(pares).forEach((clave) => {
        if (form.querySelector(`input[name="${clave}"]`)) return;
        const campo = document.createElement('input');
        campo.type = 'hidden';
        campo.name = clave;
        campo.value = pares[clave];
        form.appendChild(campo);
      });
    },
    true
  );

  /* Y si se entra directo a una de esas trece fichas (dirección pegada,
     recarga, o un enlace que este guion no llegó a interceptar), se corrige
     la propia página. Se usa replace y no href para no dejar el paso a
     medias metido en el historial: al pulsar "atrás" se vuelve a donde se
     estaba, no a la misma ficha sin plantilla. */
  (function corregirEstaPagina() {
    if (!enPrevia()) return;
    const aqui = new URL(window.location.href);
    if (aqui.searchParams.has('view')) return;
    const v = plantillaDe(aqui.pathname);
    if (!v) return;
    aqui.searchParams.set('view', v);
    aqui.searchParams.set('_fd', '0');
    window.location.replace(aqui.toString());
  })();

  /* ------------------------------------------------------------------
     Las peticiones que el tema se hace a si mismo, en vista previa

     Medido el 26-ago-2026, y es el fallo mas caro de los que quedaban: al
     elegir otra piedra en Choose your stone el boton de compra se quedaba en
     "Unavailable" y ya no volvia. Pasaba en los nueve modelos.

     Lo que ocurre de verdad, leido en la red del navegador: al cambiar de
     variante Dawn se pide a si mismo el trozo de ficha
       /products/alba?section_id=...__main&option_values=...
     Esa peticion NO lleva _fd=0 —la escribe el tema, no nosotros—, asi que
     Shopify la manda con un 301 a umya.be, y alli el tema publicado no tiene
     esa seccion: 404. Dawn se queda sin respuesta y deja el boton apagado.

     No es un fallo del tema ni se vera al publicar: es la vista previa otra
     vez. Aqui se le pone _fd=0 a toda peticion que el tema se haga a su
     propio dominio, que es justo lo que le falta.
     ------------------------------------------------------------------ */
  (function peticionesEnPrevia() {
    if (!enPrevia()) return;
    const original = window.fetch;
    if (typeof original !== 'function' || original.umyaParcheado) return;

    const conFd = (valor) => {
      const u = new URL(String(valor), window.location.origin);
      if (u.host !== window.location.host) return null;
      if (u.searchParams.get('_fd') === '0') return null;
      u.searchParams.set('_fd', '0');
      return u.toString();
    };

    const parcheado = function (entrada, opciones) {
      try {
        if (typeof entrada === 'string' || entrada instanceof URL) {
          const nueva = conFd(entrada);
          if (nueva) entrada = nueva;
        } else if (entrada && entrada.url) {
          const nueva = conFd(entrada.url);
          if (nueva) entrada = new Request(nueva, entrada);
        }
      } catch (e) {
        /* si algo no encaja, la peticion se manda tal cual venia */
      }
      return original.call(this, entrada, opciones);
    };
    parcheado.umyaParcheado = 1;
    window.fetch = parcheado;
  })();

  /* ------------------------------------------------------------------
     El carrito, en vista previa

     Medido el 21-ago-2026: al anadir algo desde la vista previa, Shopify
     mete la pieza al carrito de verdad (responde bien) pero devuelve VACIO
     el trozo de pagina que Dawn necesita para refrescar el contador y abrir
     el cajon. Comprobado pidiendo secciones a pelo: las del tema publicado
     (Brooklyn) llegan enteras; las de este tema llegan a nulo, todas. La
     API que sirve trozos de pagina ignora el tema en vista previa.

     O sea: NO es un fallo del tema, y desaparece solo el dia que se publique.
     Pero mientras tanto quien prueba la vista previa pulsa "anadir" y no ve
     pasar nada, que es exactamente lo que no se le puede hacer a Ushas.

     Aqui se tapa el hueco sin tocar nada de lo que ira a produccion: si la
     respuesta viene sin trozos, se refresca el contador con los datos del
     carrito y se lleva a la pagina del carrito, que esa si se pinta con el
     tema que se esta mirando.
     ------------------------------------------------------------------ */
  (function carritoEnPrevia() {
    if (!enPrevia()) return;

    /* Este guion se carga en la cabecera, antes de que exista el cajon del
       carrito. Buscarlo aqui mismo devolvia null y el parche no llegaba a
       ponerse (comprobado el 21-ago: el error de cart-drawer seguia saliendo
       igual). Por eso se espera a que la pagina este montada. */
    const poner = () => {
      const cajon = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (!cajon || typeof cajon.renderContents !== 'function') return;

      const alCarrito = () => {
        /* Con _fd=0 para no acabar en umya.be: al cambiar de dominio se
           pierde la galleta del carrito y llegarias a un carrito vacio. */
        const destino = new URL(window.routes.cart_url, window.location.origin);
        destino.searchParams.set('_fd', '0');
        window.location = destino.toString();
      };

      const original = cajon.renderContents.bind(cajon);
      cajon.renderContents = function (estado) {
        const trozos = estado && estado.sections;
        const sirve = trozos && Object.keys(trozos).some((k) => trozos[k]);
        if (sirve) return original(estado);

        fetch(window.routes.cart_url + '.js?_fd=0')
          .then((r) => r.json())
          .then((carro) => {
            const burbuja = document.getElementById('cart-icon-bubble');
            if (burbuja && carro.item_count) {
              burbuja.innerHTML = '<span class="umya-cart-count">' + carro.item_count + '</span>';
            }
          })
          .catch(() => {})
          .finally(alCarrito);
      };
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', poner);
    } else {
      poner();
    }
  })();

})();
